/* Mrays — small, dependency-free behaviour.
   Motion is deliberately short and ease-out; long slow fades are the
   fastest way to make a site feel machine-made. */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── sticky nav ─────────────────────────────────────── */
  var nav = document.getElementById('nav');
  var onScroll = function () {
    nav.classList.toggle('is-stuck', window.scrollY > 24);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ── mobile drawer ──────────────────────────────────── */
  var burger = document.getElementById('burger');
  var drawer = document.getElementById('drawer');
  var scrim = document.getElementById('scrim');

  var setDrawer = function (open) {
    nav.classList.toggle('is-open', open);
    burger.setAttribute('aria-expanded', String(open));
    burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    // body scroll-lock only while the drawer covers the page, never on desktop
    document.body.classList.toggle('no-scroll', open);
  };

  burger.addEventListener('click', function () {
    setDrawer(!nav.classList.contains('is-open'));
  });

  scrim.addEventListener('click', function () { setDrawer(false); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) setDrawer(false);
  });

  drawer.addEventListener('click', function (e) {
    if (e.target.tagName === 'A') setDrawer(false);
  });

  /* ── scroll reveal — 12px, 420ms, 40ms stagger ──────── */
  var io = null;
  if (!reduced && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      // stagger only within a single batch, so a section animates as a group
      var shown = 0;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.style.setProperty('--d', (shown * 40) + 'ms');
        entry.target.classList.add('is-in');
        shown++;
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  }

  var observeReveals = function (root) {
    var items = Array.prototype.slice.call((root || document).querySelectorAll('.reveal:not(.is-in)'));
    if (io) {
      items.forEach(function (el) { io.observe(el); });
    } else {
      items.forEach(function (el) { el.classList.add('is-in'); });
    }
  };

  observeReveals();
  // exposed so pages that inject content after load (e.g. the journal's
  // search results) can bring new .reveal elements into the same system
  window.mraysRevive = observeReveals;

  /* ── pricing tabs ───────────────────────────────────── */
  var tabs = Array.prototype.slice.call(document.querySelectorAll('.tabs__btn'));
  var panels = Array.prototype.slice.call(document.querySelectorAll('[data-panel]'));

  tabs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.dataset.tab;
      tabs.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', String(on));
      });
      panels.forEach(function (p) {
        p.hidden = p.dataset.panel !== key;
      });
    });
  });

  /* ── parts rail arrows ──────────────────────────────── */
  var partsRail = document.getElementById('partsRail');
  var partsPrev = document.getElementById('partsPrev');
  var partsNext = document.getElementById('partsNext');

  if (partsRail && partsPrev && partsNext) {
    var scrollParts = function (dir) {
      partsRail.scrollBy({ left: dir * 372, behavior: reduced ? 'auto' : 'smooth' });
    };
    partsPrev.addEventListener('click', function () { scrollParts(-1); });
    partsNext.addEventListener('click', function () { scrollParts(1); });
  }

  /* ── booking form ───────────────────────────────────── */
  var form = document.getElementById('bookForm');
  var msg = document.getElementById('formMsg');

  /* The device field is checked against the catalog rather than accepting any
     text — "asdf" used to book a repair. MODELS_BY_BRAND is loaded by the
     section; if it somehow isn't there the field falls back to the old
     not-empty check, so the form can never become unusable. */
  var DEVICE_INDEX = [];
  (function buildIndex() {
    if (typeof MODELS_BY_BRAND === 'undefined') return;
    var labels = (typeof BRAND_LABEL !== 'undefined') ? BRAND_LABEL : {};
    Object.keys(MODELS_BY_BRAND).forEach(function (brand) {
      MODELS_BY_BRAND[brand].forEach(function (model) {
        var label = labels[brand] || brand;
        // Several catalogs already carry the brand inside the model name
        // ("OnePlus 12", "realme 11 Pro", "Nokia G42"), so prefixing blindly
        // produced "OnePlus OnePlus 12".
        var already = model.toLowerCase().indexOf(label.toLowerCase()) === 0;
        var display = already ? model : label + ' ' + model;
        DEVICE_INDEX.push({ display: display, model: model, brand: brand, label: label });
      });
    });
  })();

  function norm(s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, ''); }

  function findDevice(text) {
    var n = norm(text);
    if (!n) return null;
    for (var i = 0; i < DEVICE_INDEX.length; i++) {
      var d = DEVICE_INDEX[i];
      if (norm(d.display) === n || norm(d.model) === n) return d;
    }
    return null;
  }

  function suggestDevices(text, limit) {
    var n = norm(text);
    if (n.length < 2) return [];
    var starts = [], contains = [];
    for (var i = 0; i < DEVICE_INDEX.length && starts.length < limit; i++) {
      var hay = norm(DEVICE_INDEX[i].display);
      if (hay.indexOf(n) === 0) starts.push(DEVICE_INDEX[i]);
      else if (contains.length < limit && hay.indexOf(n) !== -1) contains.push(DEVICE_INDEX[i]);
    }
    return starts.concat(contains).slice(0, limit);
  }

  var deviceInput = form && form.device;
  var suggestEl = document.getElementById('deviceSuggest');
  var activeIdx = -1;

  function closeSuggest() {
    if (!suggestEl) return;
    suggestEl.hidden = true;
    suggestEl.innerHTML = '';
    activeIdx = -1;
    deviceInput.setAttribute('aria-expanded', 'false');
  }

  function openSuggest(matches) {
    if (!suggestEl) return;
    if (!matches.length) return closeSuggest();
    suggestEl.innerHTML = matches.map(function (d, i) {
      return '<li role="option" id="devopt' + i + '" data-value="' + d.display.replace(/"/g, '&quot;') + '">' +
             d.display + '</li>';
    }).join('');
    suggestEl.hidden = false;
    activeIdx = -1;
    deviceInput.setAttribute('aria-expanded', 'true');
  }

  function setActive(next) {
    var items = suggestEl.querySelectorAll('li');
    if (!items.length) return;
    if (activeIdx > -1) items[activeIdx].classList.remove('is-active');
    activeIdx = (next + items.length) % items.length;
    items[activeIdx].classList.add('is-active');
    deviceInput.setAttribute('aria-activedescendant', items[activeIdx].id);
  }

  function commit(value) {
    deviceInput.value = value;
    closeSuggest();
    msg.textContent = '';
    msg.className = 'cta__msg';
  }

  if (deviceInput && suggestEl && DEVICE_INDEX.length) {
    deviceInput.addEventListener('input', function () {
      openSuggest(suggestDevices(deviceInput.value, 6));
    });
    deviceInput.addEventListener('keydown', function (e) {
      if (suggestEl.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(activeIdx + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(activeIdx - 1); }
      else if (e.key === 'Enter' && activeIdx > -1) {
        e.preventDefault();
        commit(suggestEl.querySelectorAll('li')[activeIdx].dataset.value);
      } else if (e.key === 'Escape') closeSuggest();
    });
    suggestEl.addEventListener('mousedown', function (e) {
      var li = e.target.closest('li');
      if (li) { e.preventDefault(); commit(li.dataset.value); }
    });
    // A click outside should dismiss it, but blur alone would fire before a
    // suggestion click registers — mousedown above is what makes that safe.
    document.addEventListener('click', function (e) {
      if (!suggestEl.hidden && !suggestEl.contains(e.target) && e.target !== deviceInput) closeSuggest();
    });
  }

  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var device = form.device.value.trim();
    var phone = form.phone.value.replace(/\s+/g, '');

    msg.className = 'cta__msg';

    if (!device) {
      msg.textContent = 'Tell us which device it is.';
      msg.classList.add('is-err');
      form.device.focus();
      return;
    }

    // Must be a device we actually list. Skipped only if the catalog failed to
    // load, so a script problem can't block every booking.
    var matched = null;
    if (DEVICE_INDEX.length) {
      matched = findDevice(device);
      if (!matched) {
        msg.textContent = 'Please enter a valid mobile name.';
        msg.classList.add('is-err');
        form.device.focus();
        openSuggest(suggestDevices(device, 6));
        return;
      }
    }
    if (!/^(\+?\d{1,3})?\d{10}$/.test(phone)) {
      msg.textContent = 'That phone number doesn’t look right.';
      msg.classList.add('is-err');
      form.phone.focus();
      return;
    }

    // No backend — booking goes straight to WhatsApp with the details filled in.
    var business = form.dataset.business || 'Mrays';
    // Send the catalog's own spelling, so the shop gets "Apple iPhone 13 Pro
    // Max" rather than whatever casing the customer typed.
    var deviceName = matched ? matched.display : device;
    var waText = 'Hi ' + business + ', I’d like to book a repair.\n\n'
      + 'Device: ' + deviceName + '\n'
      + 'My number: ' + phone;
    var waNumber = form.dataset.whatsapp || '918712307510';
    var waUrl = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(waText);

    msg.textContent = 'Opening WhatsApp — send the message to confirm.';
    msg.classList.add('is-ok');
    window.open(waUrl, '_blank', 'noopener');
    form.reset();
  });
})();
